export default "__VITE_ASSET__9819e5b8__"